import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject } from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';

import { BehaviorSubject, EMPTY, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { filePath, SwalService } from '@atmi/core';
import { BaseFormComponent, FormManagerService } from '@sim/form';

import { Media, MediaMeta } from '../../models/media';
import { MediaService } from '../../services/media.service';
import { UIMediaService } from '../../services/ui-media.service';
import { extractMediaNameFromPath, extractMediaTypeFromPath } from '../../utils';

interface State {
  filesToUpload: File[];
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-media-manager-data',
  styleUrls: ['./media-manager-data.component.scss'],
  templateUrl: './media-manager-data.component.html',
})
export class MediaManagerDataComponent extends BaseFormComponent<Media> {

  state$ = new BehaviorSubject<State>({
    filesToUpload: [],
  });
  get state() {
    return this.state$.value;
  }

  get imageUrl() {
    const originalUrl = this.entityForm ? `${this.fileUrl}${this.entityForm.value.previewUrl}` : '';

    return this.formEditData && originalUrl ? originalUrl : undefined;
  }

  get mediaName() {
    return this.formEditData && this.entityForm
      ? extractMediaNameFromPath(this.entityForm.value.path)
      : '-';
  }

  get mediaType() {
    return this.formEditData && this.entityForm
      ? extractMediaTypeFromPath(this.entityForm.value.path)
      : '-';
  }

  constructor(
    @Inject(filePath) private readonly fileUrl: string,
    private readonly mediaApi: MediaService,
    private readonly swal: SwalService,
    private readonly uiMediaService: UIMediaService,
    protected readonly cd: ChangeDetectorRef,
    protected readonly formManager: FormManagerService,
    protected readonly route: ActivatedRoute,
    protected readonly router: Router,
    protected readonly snackBarService: MatSnackBar,
    protected readonly spinner: NgxSpinnerService,
    protected readonly translate: TranslateService,
  ) {
    super(snackBarService, translate, route, formManager, spinner, cd, MediaMeta, ((id) => mediaApi.get(id as string)), '/media', router);
  }

  addConcrete() {
    return EMPTY;
  }

  editConcrete(media: Media) {
    return this.mediaApi.put(media);
  }

  removeConcrete(media: Media) {
    if (media.id) {
      const res = this.swal.showConfirm({
        text: this.translate.instant('Sei sicuro di voler rimuovere questo media?'),
        title: this.translate.instant('Rimozione media'),
      });

      return from(res).pipe(
        switchMap((r) => r && media.id
          ? this.mediaApi.remove(media.id)
          : EMPTY
        )
      );
    }
    return EMPTY;
  }

  resetFormConcrete() {
    return EMPTY;
  }

  showMediaHandler(media: Media & { id: string } ) {
    this.uiMediaService.dispatchViewMediaAction(media);
  }
}
